import AnswerFreeform from './AnswerFreeform';
import AnswerMultiSelect from './AnswerMultiSelect';
import AnswerRange10 from './AnswerRange10';
import AnswerRating5 from './AnswerRating5';

import type { PulseReportDeltaByQuestionKey } from './deltaTypes';
import type { PulseReportAnswer } from '@/types';
import type { FC } from 'react';

interface AnswerProps {
  answer: PulseReportAnswer;
  deltaByQuestionKey?: PulseReportDeltaByQuestionKey;
}

const Answer: FC<AnswerProps> = ({ answer, deltaByQuestionKey }) => {
  const answerDelta = deltaByQuestionKey?.[answer.questionKey];

  switch (answer.kind) {
    case 'range10':
      return <AnswerRange10 answer={answer} delta={answerDelta} />;
    case 'freeform':
      return <AnswerFreeform answer={answer} />;
    case 'multi_select':
      return <AnswerMultiSelect answer={answer} />;
    case 'rating5':
      return <AnswerRating5 answer={answer} delta={answerDelta} />;
    default:
      return null;
  }
};

export default Answer;
